import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BatchService } from 'projects/services/src/app/API/batch.service';
import { Constants } from 'projects/shared/src/app/shared/constants/constants';
import { ApplicantDataService } from 'projects/services/src/app/applicant-data.service';

declare const swal: any;

@Component({
	selector: 'app-search-result-for-applicant',
	templateUrl: './search-result-for-applicant.component.html',
	styleUrls: ['./search-result-for-applicant.component.css']
})
export class SearchResultForApplicantComponent implements OnInit {
	@Input() searchedData: any;
	@Output() sendData = new EventEmitter();
	pageNum = 1;
	pageNo = 0;
	recordsPerPage: number = Constants.RECORDSPERPAGE;
	constructor(
		private _batchService: BatchService,
		private _applicantDataService: ApplicantDataService
	) { }

	ngOnInit() {
		console.log(this.searchedData,"testing searchedData");
	}

	// setPaginationData(): void {
	// 	this._applicantDataService.setPaginationData('data');
	// }

	applyToBatch(data) {
		this.sendData.emit({ data });
		// this._batchService.applyForBatch(data.batchId).subscribe(res => {
		// 	console.log(res);
		// 	if (res) {
		// 		swal(
		// 			'Applied Successfully',
		// 			'You have successfully applied for ' + data.batchName,
		// 			//  + 'and batch id - ' + data.batchId
		// 			'success'
		// 		);
		// 	}
		// });
	}

}
